import { type MessageDescriptor } from 'react-intl'

import fr from './fr.json'

export const stringIsMessageId = (str?: string): str is keyof MessageDescriptor['id'] =>
  str !== undefined && Object.keys(fr).includes(str)
